const questions = [
  {
    id: 0,
    question: "What is NASA's Astronomy Picture of the Day (APOD) API?",
    answer:
      "The APOD API is an interface provided by NASA that allows developers to access and retrieve data related to the daily Astronomy Picture of the Day. It provides programmatic access to a vast collection of stunning astronomical images, along with their descriptions, credits, and other relevant metadata.",
  },
  {
    id: 1,
    question:
      "How did the Astronomy Picture of the Day (APOD) initiative start?",
    answer:
      "The APOD initiative began in 1995 as a way to share captivating images of the universe with the general public. It was created by Robert Nemiroff, a professor of physics, and Jerry Bonnell, a NASA astrophysicist. Their goal was to showcase the beauty and wonder of astronomy by featuring a different astronomical image or photograph every day, along with a brief description written by an astronomer.",
  },
  {
    id: 2,
    question:
      "Who is responsible for curating the Astronomy Picture of the Day (APOD) collection?",
    answer:
      "The APOD collection is curated by a team of professional astronomers and astrophysicists. They carefully select each image based on its scientific significance, aesthetic appeal, and educational value. The team strives to provide a diverse range of astronomical subjects, including galaxies, nebulae, planets, stars, and other celestial phenomena.",
  },
  {
    id: 3,
    question:
      "How frequently is the Astronomy Picture of the Day (APOD) updated?",
    answer:
      "The APOD website is updated daily with a new image and description. The APOD API allows developers to retrieve the latest picture of the day as well as access the archive of previous images, dating back to the initiative's inception in 1995.",
  },
  {
    id: 4,
    question: "Who can use NASA's Astronomy Picture of the Day (APOD) API?",
    answer:
      "The APOD API is available for use by developers, researchers, educators, and enthusiasts who wish to incorporate NASA's astronomy images and information into their applications, websites, or educational materials. It is free to use and does not require any special permissions or licenses.",
  },
  {
    id: 5,
    question:
      "What can I do with the data obtained through the Astronomy Picture of the Day (APOD) API?",
    answer:
      "With the APOD API, you can programmatically retrieve the image of the day, its description, credits, and other metadata. This allows you to display the daily astronomy image on your own website or application, build interactive galleries, create educational materials, or conduct research using the vast collection of astronomical images and information provided by NASA.",
  },
  {
    id: 6,
    question:
      "Are there any usage guidelines or restrictions for the Astronomy Picture of the Day (APOD) API?",
    answer:
      "NASA provides guidelines for the use of its APIs, including the APOD API, to ensure appropriate and respectful usage of the data. It is important to adhere to these guidelines and give proper credit to NASA and the original image sources when using the APOD content. The full terms of use can be found on NASA's website.",
  },
  {
    id: 7,
    question:
      "Can I contribute my own astronomical images to the Astronomy Picture of the Day (APOD) collection?",
    answer:
      "Yes, you can submit your own astronomical images to be considered for the APOD collection. NASA accepts submissions from professional and amateur astronomers alike. However, please note that the selection process is highly competitive, and not all submissions can be featured. Instructions for submitting images can be found on the official APOD website.",
  },
  {
    id: 8,
    question:
      "Is the Astronomy Picture of the Day (APOD) API available in multiple programming languages?",
    answer:
      "Yes, the APOD API is language-agnostic, which means it can be used with any programming language that supports making HTTP requests and parsing JSON data. NASA provides example code snippets and documentation to assist",
  },
];

export default questions;
